export default __webpack_public_path__ + "img/g100.9e8c231f.png";